import { createStore } from "vuex";
import di from 'di'

import { productsStore } from "common/js/store/products";
import { promotionsStore } from "common/js/store/promotions";
import { assetsStore } from "common/js/store/assets";
import { tickerStore } from "common/js/store/ticker";
import { styleStore } from "common/js/store/style";

import { playerStore } from '@/js/store/player'

export default function(app){

    const store = createStore({
        modules: {
            products: productsStore,
            promotions: promotionsStore,
            player: playerStore,
            assets: assetsStore,
            ticker: tickerStore,
            style: styleStore
        }
    });

    // Store
    app.use(store);
    di.set('store', store);
}